import { faCircle } from "@jewlr/pro-solid-svg-icons/faCircle"
import { faDiamond } from "@jewlr/sharp-solid-svg-icons/faDiamond"
import { faHeart } from "@jewlr/sharp-solid-svg-icons/faHeart"
import { faSquare } from "@jewlr/sharp-solid-svg-icons/faSquare"
import PropTypes from "prop-types"
import { Fragment } from "react"
// import { useSelector } from "react-redux"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import useWindowDimensions from "helpers/window-dimensions"
import { cn } from "styles/utils"

const confettiMap = {
  0: faDiamond,
  1: faSquare,
  2: faCircle,
  3: faHeart,
}

const LandingMarquee = ({ element }) => {
  // const homepageExp = useSelector(
  //   (state) => state.experiment.homepage.variant_id
  // )
  const { isTablet } = useWindowDimensions()

  const items = (hidden = false) =>
    (element.data?.items || []).map((item, i) => {
      return (
        <Fragment key={`marquee-${i}`}>
          <li
            className={cn(
              "inline-block",
              "desktop:mx-6 large:mx-8 widescreen:mx-12 xlarge:mx-16 mx-16",
              // homepageExp === 1
              //   ? "desktop:mx-6 large:mx-8 widescreen:mx-12 xlarge:mx-16 mx-16"
              //   : "mx-16",
              element.style?.classNames?.itemClassName,
              item.style?.className
            )}
            {...(hidden && { "aria-hidden": true })}
            {...element.style?.itemProps}
            role="none"
          >
            <FontAwesomeIcon
              className={cn(
                "text-10",
                "desktop:text-8 large:text-10"
                // homepageExp === 1 && "desktop:text-8 large:text-10"
              )}
              icon={confettiMap[i % 4]}
            />
          </li>
          <li
            className={cn(
              "inline-block align-middle",
              "desktop:mx-8 widescreen:mx-12 large:mx-8 xlarge:mx-16 mx-16",
              // homepageExp === 1
              //   ? "desktop:mx-8 widescreen:mx-12 large:mx-8 xlarge:mx-16 mx-16"
              //   : "mx-16",
              element.style?.classNames?.itemClassName,
              item.style?.className
            )}
            {...(hidden && { "aria-hidden": true })}
            {...element.style?.itemProps}
          >
            {item.text}
          </li>
        </Fragment>
      )
    })

  return (
    <div
      className={cn(
        "bg-black-print text-white",
        element.style?.classNames?.blockClassName
      )}
      {...element.style?.blockProps}
    >
      <div
        className={cn(
          "mask-fade",
          "py-20",
          // homepageExp === 1 ? "py-20" : "py-32",
          element.contain && "contained-wide",
          element.style?.classNames?.containerClassName
        )}
        {...element.style?.containerProps}
      >
        <div
          className={cn(
            "body user-select-none leading-20 relative flex overflow-hidden font-semibold",
            "desktop:justify-center desktop:text-13 large:text-16 xlarge:text-19 tracking-tight"
            // homepageExp === 1 &&
            //   "desktop:justify-center desktop:text-13 large:text-16 xlarge:text-19 tracking-tight"
          )}
        >
          <ul
            className={cn(
              "animate-scroll min-w-fit shrink-0 list-none items-baseline justify-around uppercase",
              "desktop:animate-none",
              // homepageExp === 1 && "desktop:animate-none",
              element.style?.classNames?.marqueeClassName
            )}
            {...element.style?.marqueeProps}
          >
            {items()}
            {isTablet && items(true)}
            {/* {(homepageExp !== 1 || isTablet) && items(true)} */}
          </ul>
          <ul
            aria-hidden
            className={cn(
              "animate-scroll min-w-fit shrink-0 list-none items-baseline justify-around uppercase",
              "desktop:hidden",
              // homepageExp === 1 && "desktop:hidden",
              element.style?.classNames?.marqueeClassName
            )}
            {...element.style?.marqueeProps}
          >
            {items()}
            {items()}
          </ul>
        </div>
      </div>
    </div>
  )
}

LandingMarquee.propTypes = {
  element: PropTypes.object,
}

export default LandingMarquee
